<template>
  <div :style="containerStyle">
    <div v-if="isFreePlan" class="ba-top-alert ba-info alert-no-active-plan">
        <div>
          <span>{{ t.alert_no_active_plan }}</span>
        </div>
    </div>
    <builderall-loader :loading="loading" :style="baLoaderStyle">
    <div class="overlay" v-if="showPopupOneClickConfirmation"></div>
    <div v-if="plans.length > 0">
      <h1 class="ba-text-center ba-montserrat-800">{{ t.upgrade_unlock_more_features }}</h1>
      <div class="ba-flex ba-gp-4 ba-ai-center ba-jc-center ba-mg-2 resources-included ba-montserrat">
        <span>
          {{ t.all_plans_included }}
        </span>
        <span class="ba-flex">
          <builderall-icon code='3791'></builderall-icon>
          {{ t.secure_website_hosting }}
        </span>
        <span class="ba-flex">
          <builderall-icon code='3791'></builderall-icon>
          {{ t.prefessional_email_yourdomain }}
        </span>
        <span class="ba-flex">
          <builderall-icon code='3791'></builderall-icon>
          {{ t.customer_success_24_7 }}
        </span>
      </div>
      <ba-plans
          :plans-list="plans.join(',')"
          :country="country"
          :button-name="t.switch_to_plan"
          :font="plansFont"
          :background="plansBackgroundColor"
          :card-background="plansBackgroundCardColor"
          :emit-click-plan-button="oneclick"
          :lang="this.getComponentLanguage()"
          plan-bundle="true"
          @clickPlanButton="showConfirmOneClickCheckout"
      ></ba-plans>
      <div class='ba-card-alert ba-info oneclick-popup' v-if="showPopupOneClickConfirmation">
          <p>{{ t.are_you_sure_switch_plan }}</p>
          <span class="ba-mg-b-1">{{ t.confirm_immediately_charge }}</span>
          <div class='ba-buttons'>
            <button @click="showPopupOneClickConfirmation = false" class='ba-btn ba-md'>{{ t.cancel }}</button>
            <button class='ba-btn ba-md ba-blue' @click="confirmOneClick()">{{ t.confirm }}</button>
          </div>
      </div>
    </div>
    <div v-else class="ba-jc-center ba-ai-center ba-flex no-plans-container">
        <div class='no-plans-card ba-card ba-500'>
          <span class='ba-title'>{{ t.all_in_one_place }}</span>
          <span class='ba-description'>{{ t.we_are_happy_to_have_you }}</span>
          <span class='ba-description'>{{ t.you_already_have_access_tools }}</span>
          <span class='ba-description'>{{ t.enjoy }}</span>
          <a  href="/us/office" class='ba-btn ba-md ba-blue ba-mg-t-1'>
              {{ t.continue }}
          </a>
      </div>
    </div>
  </builderall-loader>
  </div>
</template>

<script>
  import axios from "axios";
  import qs from 'qs';
  export default {
    name: "ba6-upgrade",
    props: ['plans', 'translations', 'oneclick', 'country', 'checkout', 'language'],
    data() {
      return {
        t: this.translations,
        showPopupOneClickConfirmation: false,
        loading: false,
        containerStyle: '',
        baLoaderStyle: '',
        selectedPlan: null,
        isFreePlan: false,
        plansFont: 'Montserrat',
        plansBackgroundColor: '#F8FAFD',
        plansBackgroundCardColor: '#fff'
      }
    },
    methods: {
      showConfirmOneClickCheckout(event) {
        this.showPopupOneClickConfirmation = true;
        this.selectedPlan = event.detail.planSlug
      },
      confirmOneClick () {
        this.showPopupOneClickConfirmation = false;
        this.showLoader();
        axios.post('/us/office/upgrade/oneclick', qs.stringify({ plan: this.selectedPlan }))
        .then(response => {
          if (response.data.success) {
            this.handleOneClickSuccess();
          } else {
            this.handleOneClickError();
          }
        })
        .catch(error => {
          this.handleOneClickError();
        }).finally(res => {
          this.hideLoader();
        });
      },
      showLoader () {
        this.loading        = true;
        this.containerStyle = 'height:80vh;'
        this.baLoaderStyle  = 'display:flex; height:100vh;'
      },
      hideLoader () {
        this.loading        = false;
        this.containerStyle = ''
        this.baLoaderStyle  = ''
      },
      handleOneClickSuccess() {
        alertMsg('success', this.t.success_one_click_upgrade);
        setTimeout(() => {
          window.location = `/us/office`
        }, 2000)
      },
      handleOneClickError() {
        alertMsg('error', this.t.error_one_click_upgrade);
        setTimeout(() => {
          window.location = `${this.checkout}/payment/${this.selectedPlan}`
        }, 2000)
      },
      getComponentLanguage() {
        return {
          us: 'en',
          de: 'de',
          it: 'it',
          br: 'pt',
          es: 'es',
          fr: 'fr'
        }[this.language] || 'en';
      }
    },
    created() {
      this.isFreePlan = new URLSearchParams(window.location.search).get('is_free_plan') === 'true';
    }
  }
</script>

<style scoped lang="scss">
  builderall-icon{
      --builderall-icon-size: 24px;
      --builderall-icon-color: #01D47B;
      margin-right: 3px;
  }

  .resources-included {
    font-size: 17px;
    color: #54779E;
    gap: 25px;
  }

  @media (max-width: 768px) {
    .resources-included {
      flex-direction: column;
      gap: 20px;
    }
  }

  .overlay {
    position: absolute;
    top: -10%;
    left: 0;
    width: 120vw;
    height: 150%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1000;
  }

  .oneclick-popup {
    position: absolute;
    left: 50%;
    top: 30vh;
    z-index: 99999;
    transform: translate(-50%, -50%);
    min-width: 400px;
  }

  .no-plans-container {
    height: 50vh;
  }

  .no-plans-card {
    align-items: center;
    text-align: center;
  }

  .alert-no-active-plan {
    padding: 25px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/upgrade/Index.vue